export const REQUEST_PROFILE_TAB_POSTS_FILTER_KEY = 'request'

export const QA_NAME_REQUEST_PROFILE_TAB_POSTS = 'requestProfileTabPosts'

export const QA_NAME_REQUEST_PROFILE_TAB_POSTS_ADD_NEW =
  'requestProfileTabPostsAddNew'
